let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3l7D0")).then(() => parcelRequire('bsnRM'));